var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeIconMini = function SvgYoutubeIconMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    y: 0.071,
    fill: "#99A2AD",
    rx: 7.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.275 7.839c.582.15 1.039.585 1.194 1.137.281 1.002.281 3.095.281 3.095s0 2.092-.281 3.095c-.157.554-.615.99-1.194 1.137-1.053.268-5.275.268-5.275.268s-4.22 0-5.275-.268a1.66 1.66 0 0 1-1.194-1.137c-.281-1.003-.281-3.095-.281-3.095s0-2.093.281-3.095c.157-.554.615-.99 1.194-1.137C7.78 7.57 12 7.57 12 7.57s4.222 0 5.275.268m-3.117 4.232L10.651 14v-3.858z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutubeIconMini;